"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _SubscriptionSuccessBox = require("./SubscriptionSuccessBox.scss");

var _SubscriptionSuccessBox2 = _interopRequireDefault(_SubscriptionSuccessBox);

var _Header = require("./Header");

var _Header2 = _interopRequireDefault(_Header);

var _MigrationBoxFooter = require("./MigrationBoxFooter");

var _MigrationBoxFooter2 = _interopRequireDefault(_MigrationBoxFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionSuccessBox = function (_React$Component) {
  (0, _inherits3.default)(SubscriptionSuccessBox, _React$Component);

  function SubscriptionSuccessBox() {
    (0, _classCallCheck3.default)(this, SubscriptionSuccessBox);
    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionSuccessBox.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionSuccessBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubscriptionSuccessBox, [{
    key: "render",
    value: function render() {
      var title = "Success";

      return _react2.default.createElement(
        "section",
        { className: _SubscriptionSuccessBox2.default.subscriptionSuccessBox },
        _react2.default.createElement(_Header2.default, { title: title }),
        _react2.default.createElement(
          "div",
          { className: _SubscriptionSuccessBox2.default.subscriptionSuccessBoxInner },
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              null,
              "We\u2019ve set you up with unlimited access.",
              _react2.default.createElement("br", null),
              "Your Megascans access is licensed for use with Unreal Engine only."
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _SubscriptionSuccessBox2.default.button },
            _react2.default.createElement(_Button2.default, {
              small: true,
              mode: "secondary",
              href: "/megascans/library/latest",
              label: "Browse Megascans"
            })
          )
        ),
        _react2.default.createElement(_MigrationBoxFooter2.default, null)
      );
    }
  }]);
  return SubscriptionSuccessBox;
}(_react2.default.Component);

exports.default = SubscriptionSuccessBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SubscriptionSuccessBox.jsx
// module id = 2918
// module chunks = 0